export const HORSE_RACING_101_URL = "/horse-racing-101";
